export const createZipMap = service_districts => {
  return service_districts.reduce(function(acc, current) {
    // add each zip code within each subsection as key with parent district as value.  e.g. {"10007": "NY",...}
    current.service_district_subsections.forEach(sds => {
      sds.zip_codes.forEach(zip => {
        acc[zip] = current.name;
      });
    });
    return acc;
  }, {});
};

export const maskServiceDistricts = array => {
  if (array && array.length) {
    return array.reduce((acc, cur, ix, arr) => {
      // creae string containing location shortcodes (e.g. "NY HM")
      acc += cur.name;
      if (ix !== arr.length - 1) {
        // add a space between all but last item in array
        acc += ' ';
      }
      return acc;
    }, '');
  }
};

export const renderLocation = (service, zipMap) => {
  // Display Location shortcode if zip code is available.  Otherwise display "Outside District"
  if (service && service.address && service.address.zip_code) {
    const cleanZip = service.address.zip_code.trim();
    if (zipMap[cleanZip]) {
      return zipMap[cleanZip];
    } else {
      return 'Outside District';
    }
  }
};



// WEBPACK FOOTER //
// ./src/helpers/serviceDistrictHelpers.js